<template>
  <form class="needs-validation" @submit.prevent="addAdmin" novalidate>
    <div class="col px-0 pr-lg-3">
      <section class="bg-white rounded mb-4 p-3 p-sm-4" v-for="(memberDetail, index) in memberPages" :key="index">
        <h1 class="h2 mb-3" v-if="index === 0">{{ edit ? 'Edit' : 'Add' }} Admin</h1>
        <div class="col-12 flex-grow-1" v-if="!memberDetailsHasData && edit">
          <div class="text-center p-2">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        </div>
        <div class="alert alert-warning" v-if="errors">{{errors}}</div>
        <div class="row">
          <div class="col-12 col-md-6 form-group row no-gutters pr-xl-4">
            <div class="col-auto">
              <label for="title">Title</label>
              <select class="form-control" id="title" required v-model="memberUpdate.title">
                <option disabled></option>
                <option value="Mr">Mr</option>
                <option value="Ms">Ms</option>
                <option value="Miss">Miss</option>
                <option value="Mrs">Mrs</option>
                <option value="Dr">Dr</option>
              </select>
              <div class="invalid-tooltip">Please include the title.</div>
            </div>

            <div class="col pl-3">
              <label for="firstName">First Name</label>
              <input type="text" class="form-control" id="firstName" maxlength="40" required v-model="memberUpdate.first_name">
              <div class="invalid-tooltip">Please include the First Name.</div>
            </div>
          </div>
          <div class="col-12 col-md-6 pl-xl-4 form-group">
            <label for="lastName">Last Name</label>
            <input type="text" class="form-control" id="lastName" maxlength="40" required v-model="memberUpdate.last_name">
            <div class="invalid-tooltip">Please include the Last Name.</div>
          </div>
          <div class="col-12 col-md-6 pr-xl-4 form-group">
            <label for="email">Email Address</label>
            <input type="email" class="form-control" id="email" maxlength="255" required v-model="memberUpdate.attributes.email">
            <div class="invalid-tooltip">Please include the Email Address.</div>
          </div>
          <div class="col-12 col-md-6 pl-xl-4 form-group">
            <label for="phone">Phone Number</label>
            <input type="text" class="form-control" id="phone" maxlength="15" required v-model="memberUpdate.attributes.phone">
            <div class="invalid-tooltip">Please include the Phone Number.</div>
          </div>

          <div class="col-12 col-md-6 form-group pr-xl-4 mb-lg-0">
            <label for="password">Password</label>
            <input type="password" class="form-control" id="password" maxlength="30" :required="!edit" pattern="([A-Za-z0-9]){6,}" v-model="password.password">
            <div class="invalid-tooltip">Please include a Password of at least 6 characters, using only letters and numbers.</div>
          </div>
          <div class="col-12 col-md-6 form-group pl-xl-4 mb-lg-0">
            <label for="confirmPassword">Confirm Password</label>
            <input type="password" class="form-control" id="confirmPassword" maxlength="30" :required="!edit" v-model="password.confirmPassword">
            <div class="invalid-tooltip">Please ensure the password matches.</div>
          </div>

          <div class="col-12 d-lg-none justify-content-end">
            <button class="btn btn-block-mob btn-outline-primary" v-if="edit && memberUpdate.id && loggedInUser !== memberUpdate.id" @click.prevent="showModal = true">Delete</button>
            <button class="btn btn-block-mob btn-primary ml-lg-2" type="submit" @click="handleSubmit">{{edit ? 'Update' : 'Add Admin' }}</button>
          </div>
        </div>
      </section>
    </div>

    <desktop-action-bar>
      <button class="btn btn-block btn-primary" type="submit" @click="handleSubmit">{{edit ? 'Update' : 'Add Admin' }}</button>
      <button class="btn btn-block btn-outline-primary mt-2" v-if="edit && memberUpdate.id && loggedInUser !== memberUpdate.id" @click.prevent="showModal = true">Delete</button>
    </desktop-action-bar>

    <!-- use the modal component, pass in the prop -->
    <modal v-if="showModal" @close="showModal = false">
      <div slot="body">
        <div class="alert alert-warning text-center">
          <strong>Warning!</strong>
          <p>You are about to delete this record permanently. Are you sure?</p>
        </div>
      </div>
      <div slot="footer">
        <div class="col-12 d-flex justify-content-center">
          <button class="btn btn-primary" @click.prevent="showModal = false;deleteAdmin()">Confirm</button>
          <button class="btn btn-outline-primary ml-2" @click.prevent="showModal = false">Cancel</button>
        </div>
      </div>
    </modal>
  </form>
</template>

<script>
import axios from 'axios'
import HANDLESUBMIT from '@/mixins/formValidation.js'
import modal from '@/components/Modal'
import DesktopActionBar from '@/components/DesktopActionBar'

export default {
  name: 'AdminAddDetails',
  props: ['memberDetails', 'edit'],
  mixins: [HANDLESUBMIT],
  components: {
    modal,
    DesktopActionBar
  },
  data() {
    return {
      memberPages: 1,
      memberUpdate: { attributes: {} },
      memberDetailsHasData: false,
      showModal: false,
      success: '',
      errors: '',
      loggedInUser: Number(localStorage.userID)
    }
  },
  watch: {
    memberDetails() {
      if (Object.keys(this.memberDetails).length > 0) {
        this.memberUpdate = this.memberDetails
        this.memberDetailsHasData = true
      }
    }
  },
  methods: {
    addAdmin() {
      setTimeout(() => {
        const fields = this.memberUpdate
        const id = this.memberDetails ? this.memberDetails.id : null
        if (this.formComplete) {
          axios.post(`${this.$api}/admin/admin`, {
            id,
            title: fields.title,
            first_name: fields.first_name,
            last_name: fields.last_name,
            email: fields.attributes.email,
            phone: fields.attributes.phone,
            password: this.password.password,
            password_confirmation: this.password.confirmPassword,
            edit: !!this.edit
          }).then((response) => {
            // eslint-disable-next-line
            // console.log(response)
            if (response.data.status === 'success') {
              this.$router.push({ name: 'Admin Users', params: { success: `Admin ${this.edit ? 'edited' : 'created'} successfully.` } })
            } else if (response.data.errors.email) {
              this.success = ''
              if (response?.data?.errors?.email[0]) {
                this.errors = response.data.errors.email[0]
              } else {
                this.errors = 'Please include correct email address.'
              }
            } else {
              this.success = ''
              this.errors = 'Please ensure all fields are completed.'
            }
          }).catch((error) => {
            // eslint-disable-next-line
            console.log(error)
          })
        }
      }, 10)
    },
    deleteAdmin() {
      axios.post(`${this.$api}/admin/delete-admin`, {
        id: this.memberUpdate.id
      }).then((response) => {
        // eslint-disable-next-line
        // console.log(response)
        if (response.data.status === 'success') {
          this.$router.push({ name: 'Admin Users', params: { success: 'Admin removed successfully.' } })
        } else if (response.data.status === 'self_deletion') {
          this.success = ''
          this.errors = 'You are unable to delete your own account.'
        } else {
          // eslint-disable-next-line
          // console.log(response.data)
        }
      }).catch((error) => {
        // eslint-disable-next-line
        console.log(error)
      })
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/views/Admin/Add/AdminAddDetails.vue